import React, { Component, useState } from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonGrid, IonRow, IonCol, IonCard, IonCardHeader, IonCardContent, IonItem, IonLabel, IonInput, IonButton, IonText, IonCheckbox, withIonLifeCycle, IonSpinner, useIonViewDidEnter, useIonViewWillLeave } from '@ionic/react'
import userService from '../../resources/Authentication/userServices'
import { menuController } from '@ionic/core'
import { APPLINKS } from '../../resources/AppConst'


const SignUp = ({ match, history}) => {

    const [userName, setUserName] = useState('')
    const [password, setPassword] = useState('')
    const [firstName, setFirstName] = useState('');
    const [lastName, setlastName] = useState('');
    const [isAdmin, setisAdmin] = useState(true);

    const [error, setError] = useState('');
    const [registering, setRegistering] = useState(false);
    const [submitted, setsubmitted] = useState(false);

    const clearAll = () => {
        setUserName('')
        setPassword('')
        setFirstName('')
        setlastName('')
        setisAdmin(true)
    }
    
    useIonViewDidEnter(()=> {
        menuController.enable(false, 'mainmenu')

    })
    useIonViewWillLeave(()=> {
        menuController.enable(true, 'mainmenu')
        clearAll();
    });

    const onSubmit = (e) => {
        e.preventDefault()
        setRegistering(true);
        setsubmitted(true);
        const user = {
            userName , password , firstName , lastName, isAdmin
        }

        console.log(user);

        if ((user.firstName || user.lastName) && user.userName && user.password) {
            userService.register(user).then((res) => {
                if (res.registered) {
                    userService.logout();
                    console.log('User Registered', res);
                    setTimeout(() => {
                        history.push(APPLINKS.login);
                        window.location.reload()
                    }, 1500);
                }
            },
                error => {
                    setError(error);
                    setRegistering(false);
                    setsubmitted(false);
                }
            )
        }

    }


    return ( 
        <IonPage>
        <IonHeader>
            <IonToolbar>
                <IonTitle>Sign Up</IonTitle>
            </IonToolbar>
        </IonHeader>

        <IonContent>
            <IonGrid>
                <IonRow class='ion-justify-content-center'>
                    <IonCol class='ion-align-self-center' sizeMd='6' sizeLg='5' sizeXs='12'>
                        <IonCard>
                            <IonCardHeader>
                                <IonTitle>
                                    User Register Details
                                </IonTitle>
                            </IonCardHeader>
                            <IonCardContent>
                                <form onSubmit={onSubmit}>
                                    <IonItem>
                                        <IonLabel position='stacked'>First Name</IonLabel>
                                        <IonInput required='true' type='text' id='firstName' onIonInput={(e) => setFirstName((e.target.value).trim())}></IonInput>
                                    </IonItem>
                                <IonItem>
                                    <IonLabel position='stacked'>Last Name</IonLabel>
                                    <IonInput type='text' id='lastName' onIonInput={(e)=> setlastName((e.target.value).trim())}></IonInput>
                                </IonItem>

                                <IonItem>
                                    <IonLabel position='stacked'>Username</IonLabel>
                                    <IonInput required='true' type='text' id='userName' onIonInput={(e)=> setUserName((e.target.value).trim())}></IonInput>
                                </IonItem>
                                <IonItem>
                                    <IonLabel position='stacked'>Password</IonLabel>
                                    <IonInput required='true' type='password' id='password' onIonInput={(e)=> setPassword((e.target.value))}></IonInput>
                                </IonItem>
                                <IonItem>
                                    <IonCheckbox slot='start' checked={isAdmin}  id='isAdmin'  onIonChange={(e)=> setisAdmin(e.detail.checked)}></IonCheckbox>
                                    <IonLabel>Is Admin</IonLabel>
                                </IonItem>

                                <div className="ion-padding">
                                    <IonButton type='submit' size='default' >
                                        <IonInput type='submit'>Sign Up</IonInput>
                                    </IonButton>
                                    <IonButton href='/' size='default' >Cancel</IonButton>
                                    {registering && <IonSpinner />}

                                </div>

                                {error && <IonText class='red-text'>{error}</IonText>}

                                </form>

                            </IonCardContent>
                        </IonCard>
                    </IonCol>

                </IonRow>
            </IonGrid>
        </IonContent>
    </IonPage >

    )
}

export default SignUp
